export default __webpack_public_path__ + "static/media/robot_ss.aaa257a3.png";